import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ApplePay from 'services/ApplePay';
import { Button, Image } from 'components/ui';

/**
 * Apple Pay Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Apple Pay logo
 */
const Apple = props => {
    const [isApplePayEnabled, setIsApplePayEnabled] = useState(false);

    useEffect(() => {
        if (props.orderDetails) {
            ApplePay.getApplePaymentType(props.orderDetails).then(payType => {
                const isEnabled = payType !== ApplePay.TYPES.HIDDEN;
                setIsApplePayEnabled(isEnabled);
            });
        }
    }, [props.orderDetails]);

    const { handlePayWithApplePayClick } = props;

    if (!isApplePayEnabled) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePayWithApplePayClick}
            data-at={Sephora.debug.dataAt('apple_pay_button')}
            aria-label='Pay with Apple Pay'
            css={styles}
            width={['151px', '151px', '182px']}
        >
            <Image
                src='/img/ufe/logo-apple-pay.svg'
                alt=''
                aria-hidden='true'
                height='24px'
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#000',
    borderRadius: '22px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: '#333'
    }
};

export default wrapFunctionalComponent(Apple, 'Apple');
